import type { Schema } from '@cli-types/core-engine/schema.js'

export function collectRequiredSchemaMetadataErrors(schema: Schema, errors: string[]): void {
  if (!schema.name || typeof schema.name !== 'string') {
    errors.push('Schema must have a valid "name" field')
  }
  if (!schema.label || typeof schema.label !== 'string') {
    errors.push('Schema must have a valid "label" field')
  }
  if (!schema.description || typeof schema.description !== 'string') {
    errors.push('Schema must have a valid "description" field')
  }
  if (!schema.icon || typeof schema.icon !== 'string') {
    errors.push('Schema must have a valid "icon" field')
  }
  if (!Array.isArray(schema.fields) || schema.fields.length === 0) {
    errors.push('Schema must have at least one field via "fields" or "slot"')
  }
}
